import { IPosition } from "../../../../../../models";

export interface IActionPosition {
    position: IPosition,
    include: boolean,
    includeClc: number,
    responsible: string
    showInclude: boolean
    useStrongBox?: boolean
}